/**
 * color.ts — Color helpers (Phaser-free so they're unit-testable).
 */

/**
 * Shift a colour toward white (`t > 0`) or black (`t < 0`), by a fraction of the
 * remaining distance. `t` is clamped to [-1, 1].
 *
 * Used for detail that has to sit on *any* base colour — roof tile courses and
 * brick mortar are laid over slate, terracotta and three different bricks, so a
 * fixed tone would clash with most of them. Shifting the base keeps every
 * building's coursing in its own family.
 */
export function shadeHex(base: number, t: number): number {
  const k = t < -1 ? -1 : t > 1 ? 1 : t;
  return lerpHex(base, k >= 0 ? 0xffffff : 0x000000, Math.abs(k));
}

/** Linearly interpolate between two 0xRRGGBB colors. `t` is clamped to [0,1]. */
export function lerpHex(a: number, b: number, t: number): number {
  const k = t < 0 ? 0 : t > 1 ? 1 : t;
  const ar = (a >> 16) & 0xff;
  const ag = (a >> 8) & 0xff;
  const ab = a & 0xff;
  const br = (b >> 16) & 0xff;
  const bg = (b >> 8) & 0xff;
  const bb = b & 0xff;
  const r = Math.round(ar + (br - ar) * k);
  const g = Math.round(ag + (bg - ag) * k);
  const bl = Math.round(ab + (bb - ab) * k);
  return (r << 16) | (g << 8) | bl;
}
